// Copyright (c) StrangeBee 2023

import useLocalStorage, { LocalStorageKeys } from '@Hooks/useLocalStorage';
import React, { useState, useEffect } from 'react';
import { PinType } from './context';

export interface StoragePins {
    [key: string]: Record<string, PinType[]>;
}

interface UseStoragePinsOutput {
    pins: StoragePins;
    setPins: React.Dispatch<React.SetStateAction<StoragePins>>;
}

export const useStoragePins = (): UseStoragePinsOutput => {
    const { storage, setStorage } = useLocalStorage<StoragePins>({
        key: LocalStorageKeys.PINS,
        initialValue: {},
    });

    const [pins, setPins] = useState<StoragePins>(storage);

    useEffect(() => {
        setStorage((state) => ({ ...state, ...pins }));
    }, [pins, setStorage]);

    return { pins, setPins };
};
